import styled, { keyframes } from 'styled-components';

export const Content = styled.div`
  display: flex;
  justify-content: start;
  margin: 0 1rem 0 0;
`;

/* pulsing halo when the fire alarm is actually ON */
const alarmPulse = keyframes`
  0%, 100% { box-shadow: 0 1px 2px rgba(16, 24, 32, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.16), 0 0 0 0 rgba(204, 41, 54, 0.55); }
  50%      { box-shadow: 0 1px 2px rgba(16, 24, 32, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.16), 0 0 0 5px rgba(204, 41, 54, 0.0); }
`;

// CleverParking danger button (alarm toggle). Kept local so the shared
// RedButton used inside rack windows stays untouched.
export const AlarmButton = styled.button`
  cursor: pointer;
  border: 0;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 15px;
  color: #ffffff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  line-height: 1;
  background: linear-gradient(180deg, #d63a46 0%, #cc2936 100%);
  box-shadow: 0 1px 2px rgba(16, 24, 32, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.16);
  transition: background 0.15s ease, filter 0.15s ease, transform 0.12s ease, box-shadow 0.15s ease;

  svg {
    flex: none;
  }

  &:hover {
    background: linear-gradient(180deg, #e0454f 0%, #d1303c 100%);
    filter: brightness(1.04);
  }
  &:active {
    transform: translateY(0) scale(0.98);
    background: linear-gradient(180deg, #c02531 0%, #b8232f 100%);
  }
  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* alarm is ON — steady breathing halo so it's unmistakable */
  &.active {
    background: linear-gradient(180deg, #cc2936 0%, #b8232f 100%);
    animation: ${alarmPulse} 1.8s ease-in-out infinite;
  }
`;
